<template>
    <div class="brand-products w-full py-12">
        <h2 class="brand-products-heading text-center mb-8">{{ heading }}</h2>
        <div class="brand-products-list grid gap-8">
            <a
                v-for="(product, index) in products"
                :key="index"
                :href="product.href || '#'"
                class="brand-product flex items-center justify-between gap-4"
                :class="{ 'brand-product--reverse flex-row-reverse': index % 2 === 1 }"
            >
                <img
                    data-aos-offset="0"
                    data-aos-anchor-placement="top-bottom"
                    :data-aos="index % 2 === 0 ? 'fade-right' : 'fade-left'"
                    class="brand-product-image block w-3/5"
                    :src="product.image"
                    :alt="product.alt || ''"
                />
                <div class="brand-product-title flex flex-1 items-center justify-center w-2/5">
                    <h3 class="text-center sm:text-left">
                        <template v-for="(line, i) in titleLines(product.title)">
                            <span :key="`l-${i}`">{{ line }}</span>
                            <br v-if="i < titleLines(product.title).length - 1" :key="`br-${i}`" />
                        </template>
                    </h3>
                </div>
            </a>
        </div>
    </div>
</template>
<style scoped lang="scss">
.brand-products {
    overflow: hidden;

    .brand-product {
        color: black;
    }

    @media (max-width: 768px) {
        padding-bottom: 0;

        .brand-products-list {
            gap: 0;
        }

        .brand-product {
            position: relative;
            flex-direction: column;
            gap: 0;

            &--reverse {
                flex-direction: column;
            }

            .brand-product-image {
                width: 158%;
                filter: brightness(0.35);
            }

            .brand-product-title {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                pointer-events: none;

                h3 {
                    color: white;
                    margin: 0;
                }
            }
        }
    }
}
</style>
<script>
export default {
    name: 'BrandProducts',
    props: {
        heading: {
            type: String,
            default: ''
        },
        products: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        titleLines(title) {
            if (Array.isArray(title)) return title;
            if (typeof title === 'string') return [title];
            return [];
        }
    }
};
</script>
